module.exports = __webpack_public_path__ + "img/1-5.98fa7d40.svg";